import React from "react";
import { createBrowserRouter, RouterProvider, Navigate } from "react-router-dom";
import SignInPage from "./pages/Authentication/SignInPage";
import ErrorPage from "./pages/ErrorPage";
import { Provider } from "react-redux";
import { store } from "./store/rootStore";
import AuthContainer from "./components/AuthContainer";
import ProtectedRoute from "./components/Authentication/ProtectedRoute";
import SuperUserRoute from "./components/Authentication/SuperUserRoute";
import SignInContainer from "./components/SignInContainer";
import { CssBaseline, ThemeProvider } from "@mui/material";
import theme from "./utils/theme";
import { ConfirmDialogProvider } from "./components/shared/ConfirmDialogProvider";
import { ToastProvider } from "./components/shared/Toast";

// Layout
import MainLayout from "./layouts/MainLayout";

// Mosaic Pages
import MosaicUsersPage from "./pages/mosaic/UsersPage";
import MosaicCompaniesPage from "./pages/mosaic/CompaniesPage";
import MosaicCountriesPage from "./pages/mosaic/CountriesPage";
import MosaicDepartmentsPage from "./pages/mosaic/DepartmentsPage";
import MosaicRolesPage from "./pages/mosaic/RolesPage";
import MosaicUploadsPage from "./pages/mosaic/UploadsPage";
import MosaicHealthAreaPage from "./pages/mosaic/HealthAreaPage";

// Derin Pages
import DerinAdminControlsPage from "./pages/derin/AdminControlsPage";

// Surgo Pages
import SurgoAdminUsersPage from "./pages/surgo/AdminUsersPage";

const router = createBrowserRouter([
  {
    path: "/signin",
    element: (
      <SignInContainer>
        <SignInPage />
      </SignInContainer>
    ),
    errorElement: <ErrorPage />,
  },
  {
    path: "/",
    element: (
      <ProtectedRoute>
        <MainLayout />
      </ProtectedRoute>
    ),
    errorElement: <ErrorPage />,
    children: [
      // Default redirect to Mosaic users
      {
        index: true,
        element: <Navigate to="/mosaic/users" replace />,
      },
      // Mosaic routes
      {
        path: "mosaic",
        children: [
          { index: true, element: <Navigate to="users" replace /> },
          { path: "users", element: <MosaicUsersPage /> },
          { path: "companies", element: <MosaicCompaniesPage /> },
          { path: "countries", element: <MosaicCountriesPage /> },
          { path: "departments", element: <MosaicDepartmentsPage /> },
          { path: "roles", element: <MosaicRolesPage /> },
          { path: "uploads", element: <MosaicUploadsPage /> },
          { path: "health-area", element: <MosaicHealthAreaPage /> },
        ],
      },
      // Derin routes
      {
        path: "derin",
        children: [
          { index: true, element: <Navigate to="admin" replace /> },
          { path: "admin", element: <DerinAdminControlsPage /> },
        ],
      },
      // Surgo routes (super users only)
      {
        path: "surgo",
        element: <SuperUserRoute />,
        children: [
          { index: true, element: <Navigate to="admin-users" replace /> },
          { path: "admin-users", element: <SurgoAdminUsersPage /> },
        ],
      },
    ],
  },
  // Legacy route redirect for backward compatibility
  {
    path: "/home",
    element: <Navigate to="/mosaic/users" replace />,
  },
]);

function App() {
  return (
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <ToastProvider>
          <ConfirmDialogProvider>
            <AuthContainer>
              <RouterProvider router={router} />
            </AuthContainer>
          </ConfirmDialogProvider>
        </ToastProvider>
      </ThemeProvider>
    </Provider>
  );
}

export default App;
